import React from 'react';
import { Result, Button, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ResourceGuardProps {
  resource: string;
  minLevel?: 'read_only' | 'create' | 'full';
  children: React.ReactNode;
}

const ResourceGuard: React.FC<ResourceGuardProps> = ({ resource, minLevel = 'read_only', children }) => {
  const { canAccess, permissionsLoading } = useAuth();
  const navigate = useNavigate();

  if (permissionsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!canAccess(resource, minLevel)) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="You don't have permission to access this page."
        extra={<Button type="primary" onClick={() => navigate(-1)}>Go Back</Button>}
      />
    );
  }

  return <>{children}</>;
};

export default ResourceGuard;
